(() => {
  const drawerSelector = "cart-drawer";
  const focusableSelector =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const visibleFocusable = (container) =>
    Array.from(container.querySelectorAll(focusableSelector)).filter(
      (element) =>
        element.tabIndex >= 0 &&
        !element.closest("[inert], [hidden]") &&
        element.getAttribute("aria-hidden") !== "true" &&
        element.getClientRects().length > 0,
    );

  const syncViewportHeight = () => {
    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;
    const viewportHeight = window.visualViewport?.height || window.innerHeight;
    drawer.style.setProperty("--gg-cart-viewport-height", `${viewportHeight}px`);
  };

  const syncNewControls = (drawer) => {
    if (!drawer.hasAttribute("open")) return;
    const selector = drawer.dataset.toggleTabindex;
    if (!selector) return;
    drawer.querySelectorAll(selector).forEach((element) => {
      if (
        element.getAttribute("tabindex") === "-1" &&
        !element.closest("[inert], [hidden]")
      ) {
        element.setAttribute("tabindex", "0");
      }
    });
    drawer.querySelectorAll(".wt-cart__item__name a").forEach((link) => {
      if (!link.title) link.title = link.textContent.trim();
    });
  };

  const install = (drawer) => {
    if (drawer.dataset.ggCompactFocusReady === "true") return;
    drawer.dataset.ggCompactFocusReady = "true";

    drawer.addEventListener(
      "keydown",
      (event) => {
        if (!drawer.hasAttribute("open")) return;

        const activePanel = drawer.querySelector(
          ".wt-cart-features__drawer[open][role='dialog']",
        );
        if (event.key === "Escape" && activePanel) {
          event.preventDefault();
          event.stopImmediatePropagation();
          activePanel.closest("cart-additional-features").closeAll();
          return;
        }
        if (event.key !== "Tab") return;
        const scope = activePanel || drawer;
        const elements = visibleFocusable(scope);
        if (!elements.length) return;

        const first = elements[0];
        const last = elements[elements.length - 1];
        if (event.shiftKey && (document.activeElement === first || !scope.contains(document.activeElement))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          event.stopImmediatePropagation();
          first.focus();
        }
      },
      true,
    );

    const observer = new MutationObserver(() => {
      requestAnimationFrame(() => {
        syncNewControls(drawer);
      });
    });
    observer.observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] });
    drawer.addEventListener("cart-drawer:refresh", () => {
      syncNewControls(drawer);
    });
    syncViewportHeight();
  };

  const installAll = () => {
    document.querySelectorAll(drawerSelector).forEach(install);
    syncViewportHeight();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", installAll, { once: true });
  } else {
    installAll();
  }

  new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;
        if (node.matches(drawerSelector)) install(node);
        node.querySelectorAll(drawerSelector).forEach(install);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener("resize", syncViewportHeight, { passive: true });
  window.visualViewport?.addEventListener("resize", syncViewportHeight, {
    passive: true,
  });
})();
